/* ===========================================================================
   ROVE NEXT — PDP STOCK & VIEWER BADGES. 23 October 2026.

   One line in one strip above the Add to Cart row (markup in snippets/rn-bb-
   part-3, styles in snippets/rn-bb-part-1, .bb-live): "Only N left in stock"
   (or "Only 10+ left in stock"), a hairline, then "N others are watching".

   1. PEOPLE WATCHING. NOT a real visitor count -- there is no live presence
      feed behind it. It starts at a random number between 21 and 24 and moves
      by 1 every 3-6 seconds, always staying between 21 and 30, so it
      sits just above 20 and never jumps by a large amount. The number is kept per product for the
      browser session (sessionStorage), so a reload or a variant change
      continues from where it was rather than re-rolling.

   2. STOCK. How many of the selected variant can actually be bought -- the
      same ceiling the quantity selector enforces (total() in assets/rn-pdp-
      qty.js): real on-hand stock plus whatever pre-order allocation is left,
      or the allocation alone when Shopify is not tracking a count. Both come
      from window.RN_NOTIFY (snippets/rn-preorder-cap.liquid). 1-10 reads
      "Only N left in stock"; more than 10 reads "Only 10+ left in stock". Hidden when the total is
      0 (sold out) or unknown, rather than showing a number that is not real.

   Follows the selected variant through the same rn:bb-variant event that
   assets/rn-pdp-qty.js listens to, and reads the form's id field once on load
   in case that event fired before this deferred file arrived (Reya's grid).
   =========================================================================== */
(function () {
  var bb = document.querySelector('[id^="rn-bb-"]');
  if (!bb) return;
  var wrap = bb.querySelector('[data-bb-badges]');
  if (!wrap) return;
  var watchEl = wrap.querySelector('[data-bb-watch]');
  var watchN = wrap.querySelector('[data-bb-watch-n]');
  var stockEl = wrap.querySelector('[data-bb-stock]');
  var stockText = wrap.querySelector('[data-bb-stock-text]');

  function syncWrap() {
    wrap.hidden = !((watchEl && !watchEl.hidden) || (stockEl && !stockEl.hidden));
  }

  /* ---- 1. people watching ---------------------------------------------- */
  var MIN = 21, MAX = 30, STEP = 1; /* kept near 20, never above 30 (23 Oct 2026) */
  var key = 'rn-watch:' + location.pathname;
  var n = NaN;
  try { n = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
  if (!(n >= MIN && n <= MAX)) n = 21 + Math.floor(Math.random() * 4); /* 21-24 */

  function save() { try { sessionStorage.setItem(key, String(n)); } catch (e) {} }
  function paintWatch() {
    if (!watchEl || !watchN) return;
    watchN.textContent = n;
    watchEl.hidden = false;
    syncWrap();
  }
  /* 24 Oct 2026: "I've been staring and it's still showing 21". It used to
     tick every 6-12s and a third of ticks were 0, and at 21 a -1 was clamped
     away, so it could sit still for a minute. Now every tick moves by 1, every
     3-6s, and turns back at either end instead of stalling there. */
  function tick() {
    if (!document.hidden) {
      var d = Math.random() < 0.5 ? -STEP : STEP;
      if (n + d < MIN || n + d > MAX) d = -d;
      n += d;
      save();
      if (watchN) {
        watchN.classList.add('is-changing');
        setTimeout(function () { watchN.textContent = n; watchN.classList.remove('is-changing'); }, 180);
      }
    }
    setTimeout(tick, 3000 + Math.random() * 3000);
  }
  save();
  paintWatch();
  setTimeout(tick, 3000 + Math.random() * 3000);

  /* The eye blinks at uneven gaps (2.5-7s), about one time in five twice in
     a row, the way people do. Each blink is one .is-blink pass of the CSS
     animation in snippets/rn-bb-part-1.liquid. Skipped in a hidden tab and
     under reduced motion. */
  var eye = watchEl && watchEl.querySelector('.bb-live-eye');
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function blinkOnce() {
    eye.classList.remove('is-blink');
    void eye.getBoundingClientRect(); /* restart the animation */
    eye.classList.add('is-blink');
  }
  function blink() {
    if (!document.hidden) {
      blinkOnce();
      if (Math.random() < 0.2) setTimeout(blinkOnce, 420);
    }
    setTimeout(blink, 2500 + Math.random() * 4500);
  }
  if (eye && !still) {
    eye.addEventListener('animationend', function () { eye.classList.remove('is-blink'); });
    setTimeout(blink, 1200 + Math.random() * 1500);
  }

  /* ---- 2. stock --------------------------------------------------------- */
  var variants = {};
  var nfy = window.RN_NOTIFY;
  if (nfy && Array.isArray(nfy.variants)) nfy.variants.forEach(function (v) { variants[String(v.id)] = v; });

  /* Same rule as total() in assets/rn-pdp-qty.js, so the badge and the
     quantity selector's "Only N available" always agree. */
  function total(v) {
    if (!v) return null;
    if (v.stock === null || v.stock === undefined) {
      return v.preorderRemaining > 0 ? v.preorderRemaining : null;
    }
    return Math.max(0, v.stock) + (v.preorderRemaining || 0);
  }

  function paintStock(v) {
    if (!stockEl) return;
    var s = total(v);
    if (s === null || s <= 0) {
      stockEl.hidden = true;
    } else {
      if (stockText) stockText.innerHTML = 'Only <b>' + (s > 10 ? '10+' : s) + '</b> left in stock';
      stockEl.classList.toggle('is-low', s <= 10);
      stockEl.hidden = false;
    }
    syncWrap();
  }

  document.addEventListener('rn:bb-variant', function (e) {
    var id = e && e.detail && e.detail.id;
    paintStock(id != null ? variants[String(id)] : null);
  });
  var idEl = bb.querySelector('[data-bb-form] input[name="id"]');
  paintStock(idEl && idEl.value ? variants[String(idEl.value)] : null);
})();
